<template>
    <div>
        <div class="row" v-if="simulation">

            <div class="col-11">
                <log-content ref="log"
                    :log="log"
                    :types="types"
                    :registration="registration"
                    :degree="registration.degree"
                    :simulation="simulation"
                    :stats="stats"
                    :competencies="competencies"
                    :lang="registration.degree.lang"
                    :filters="filters"
                    :features="features"
                    role="pilot"
                    @filtersChanged="filters = $event"
                    @progressChanged="progress = $event"
                    @visibilityChanged="visibility = $event"
                    @refresh="$emit('reload-stats')">
                </log-content>
            </div>
            <div class="col-1">
                <features
                    :log="log"
                    :registration="registration"
                    :degree="registration.degree"
                    :simulation="simulation"
                    :stats="stats"
                    :competencies="competencies"
                    :lang="registration.degree.lang"
                    :types="types"
                    :filters="filters"
                    :progress="progress"
                    :visibility="visibility"
                    :features="features"
                    role="pilot"
                    @filtersChanged="filters = $event"
                    @timeslotClicked="$refs.log.scrollToTimeslot($event)"
                    @refresh="$emit('reload-stats')"
                >
                </features>
            </div>
        </div>
        <back-to-top></back-to-top>
    </div>
</template>

<script>
    import LogFeatures from './LogFeatures'
    import LogContent from '../log/LogContent'
    import Features from '../log/GlobalFeatures'

    export default {

        components: {
            LogContent, Features
        },

        props: {

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            log: {
                type: Object,
                required: true
            },

            types: {
                type: Object,
                required: true
            },
            
            competencies: {
                type: Object,
                default: null
            },
            
            stats: {
                type: Object,
                default: null
            },
        },

        data() {
            return {
                features: new LogFeatures(this.$router, this.$auth),
                showButtons: false,
                filters: {
                    selectedTypes: [],
                    selectedCompetencies: [],
                    showCompetencies: false,
                },
                progress: {},
                visibility: {},
            }
        },

        mounted() {
            $(window).scroll(() => {
                this.showButtons = $(window).scrollTop() > 300
            });
        },
    }
</script>

<style lang="css" scoped>

    .fixed-bottom {
        position: sticky;
        bottom: 30px;
        z-index: 1000;
        opacity: 0;
        visibility: hidden;
        transition:
            opacity .5s,
            visibility .5s;
    }
    .showButtons {
        opacity: 1;
        visibility: visible;
    }

</style>

